<div class="modal-primary" role="document">
    <div class="modal-content">
        <div class="modal-header borderBottom">
            <h4 class="modal-title sizef08200-title">{{title}}</h4>
            <button type="button" class="close" (click)="cancel()" aria-label="Close" style="padding: 0; margin: 0;">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <h4 class="pT20 dFlex thimg">
            <!-- <img src="assets/yxzx_ic_tx.png" alt=""> -->
            {{content}}
        </h4>
        <div class="modal-footer">
            <div class="fhBtn2 dFlex2 marginB20">
                <button (click)="cancel()" class="bgf59c7d">{{cancelButtonName}}</button>
            </div>
            <div class="fhBtn2 dFlex2 marginB20" *ngIf="confirmButtonShowFlag">
                <button (click)="confirm()" class="confirmBtn">确定</button>
            </div>

            <!-- <div><button type="button" class="btn btn-outline-primary" (click)="cancel()">1{{cancelButtonName}}</button></div>
            <div *ngIf="confirmButtonShowFlag"><button   type="button" class="btn btn-outline-primary" (click)="confirm()">确定</button></div> -->
        </div>


    </div>
</div>